module.exports = __webpack_public_path__ + "media/images/flags/64/Latvia-b0c9356ccd2fa4fc8b6374e68f768280.png";